import { useEffect } from 'react';

export const useFavicon = ({
  renderIcon,
  iconUrl,
}: {
  renderIcon: boolean;
  iconUrl?: string | null;
}) => {
  useEffect(() => {
    if (!renderIcon) return;
    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = iconUrl || '/icon.png';
  }, [iconUrl, renderIcon]);
};
